import React from "react";
import { Grid, Card } from "@design-system-coopeuch/web";
import Modal from "../../organisms/Modal/Modal";
import ContentPasswordCreation from "./ContentPasswordCreation";
import ContentAppPassCoopeuch from "./ContentAppPassCoopeuch";
import { StyleTextPasswordDigital } from "./styles";
import iconInternetPassword from "../../../assets/img/icon-internet-password.png";
import iconAppCoopeuch from "../../../assets/img/icon-app-coopeuch.png";
import iconPassCooopeuch from "../../../assets/img/icon-pass-coopeuch.png";
import IconCheck from "../../../assets/img/check-green.png";

const CardPasswordAndDigitize = (props) => {
  /* istanbul ignore next */
  const {
    phone,
    inputCodeSMS,
    password,
    confirmationPassword,
    passwordVisibility,
    confirmationPasswordVisibility,
    stateAuthSms,
    stateCreatingPassword,
    canCreatePassword,
    messagesInputAuthSms,
    storeSelected,
    onChangePasswordVisibility,
    onInvokeAuthSms,
    onTimeOverToRespond,
    onCreatePassword,
    onChange,
    onChangeStoreSelected,
    isOpenCurrentModal,
    nameCurrentModal,
    onCloseCurrentModal,
    onOpenCurrentModal,
    onRedirectToPrivateSite,
  } = props;

  const passwordAlreadyCreated =
    stateCreatingPassword === "success" ||
    sessionStorage.getItem("password-already-created") === "SI";
  /* istanbul ignore next */
  const items = [
    /* istanbul ignore next */
    {
      icon: iconInternetPassword,
      title: "Crea tu clave de internet",
      benefits: passwordAlreadyCreated
        ? [
            "Haz creado tu clave con éxito. Ahora podrás comenzar a usar los productos digitales que Coopeuch tiene para ti.",
          ]
        : [
            "<strong>Crea tu clave </strong> en solo 3 pasos.",
            "<strong>Accede a tu App y sitio en línea </strong> cuando quieras.",
          ],
      action: passwordAlreadyCreated ? "Ir a Coopeuch en línea" : "Crear clave",
      modal: passwordAlreadyCreated ? "redirect" : "password",
    },
    /* istanbul ignore next */
    {
      icon: iconAppCoopeuch,
      title: "Descarga tu app Coopeuch",
      benefits: [
        "<strong>Accede a tu App y sitio en línea </strong> cuando quieras.",
        "Podrás <strong> visualizar la información </strong> de tu Tarjeta Digital.",
        "<strong>Bloquea tus tarjetas </strong> de manera sencilla.",
      ],
      action: "Descargar app Coopeuch",
      modal: "appCoopeuch",
    },
    /* istanbul ignore next */
    {
      icon: iconPassCooopeuch,
      title: "Descarga tu app PassCoopeuch",
      benefits: [
        "<strong>Autoriza tus transacciones </strong> de forma rápida y segura.",
        "<strong>Actualiza tus datos  </strong> de forma más segura.",
      ],
      action: "Descargar app PassCoopeuch",
      modal: "passCoopeuch",
    },
  ];
  /* istanbul ignore next */
  return (
    <>
     <StyleTextPasswordDigital>
      <Card className="bg-white card-bod">
        {items.map((item, index) => (
          <Grid
            key={index}
            className="altura-grid d-flex flex-column flex-md-row align-items-center bg-white p-4 p-md-5 border-bottom gap-3 text-center text-md-start"
          >
            <StyleTextPasswordDigital>
              <div style={{ minWidth: "60px" }}>
                <img className="img-responsive-icon" src={item.icon} alt="" width="102" height="102" />
              </div>
            </StyleTextPasswordDigital>
            
            <StyleTextPasswordDigital>
            <div className="flex-grow-1 px-md-3 content-span">
              
                <p
                  style={{ color: "#383838;" }}
                  className="font-size-16 font-weight-bold mb-2 title-habilitador"
                >
                  {item.title}
                </p>
                {item.benefits.map((benefit, idx) => (
                  <p
                    key={idx}
                    style={{ color: "#383838;", fontWeight: 350 }}
                    className="font-size-14 line-height-20 m-0 mb-1 span-habilitador"
                  >
                    <img width="20" height="20" src={IconCheck} alt="Check" />{" "}
                    <span dangerouslySetInnerHTML={{ __html: benefit }} />
                  </p>
                ))}
              
            </div>
           
            <div className="text-btn">
              <button
                onClick={() =>
                  /* istanbul ignore next */
                  item.modal === "redirect"
                    ? onRedirectToPrivateSite()
                    : onOpenCurrentModal(item.modal)
                }
                style={{
                  background: "none",
                  border: "none",
                  color: "#e81e2b",
                  fontWeight: 500,
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              >
                {item.action} &nbsp; {">"}
              </button>
            </div>
            </StyleTextPasswordDigital>
          </Grid>
        ))}
      </Card>
      </StyleTextPasswordDigital>

      <Modal isOpen={isOpenCurrentModal} closeModal={onCloseCurrentModal}>
        {nameCurrentModal === "password" ? (
          <ContentPasswordCreation
            phone={phone}
            password={password}
            confirmationPassword={confirmationPassword}
            inputCodeSMS={inputCodeSMS}
            stateAuthSms={stateAuthSms}
            stateCreatingPassword={stateCreatingPassword}
            passwordVisibility={passwordVisibility}
            confirmationPasswordVisibility={confirmationPasswordVisibility}
            canCreatePassword={canCreatePassword}
            messagesInputAuthSms={messagesInputAuthSms}
            onInvokeAuthSms={onInvokeAuthSms}
            onChange={onChange}
            onTimeOverToRespond={onTimeOverToRespond}
            onCreatePassword={onCreatePassword}
            onChangePasswordVisibility={onChangePasswordVisibility}
            onCloseCurrentModal={onCloseCurrentModal}
          />
        ) : nameCurrentModal === "appCoopeuch" ||
          nameCurrentModal === "passCoopeuch" ? (
          <ContentAppPassCoopeuch
            nameCurrentModal={nameCurrentModal}
            storeSelected={storeSelected}
            onChangeStoreSelected={onChangeStoreSelected}
          />
        ) : null}
      </Modal>
    </>
  );
};

export default CardPasswordAndDigitize;
